import React, { FunctionComponent } from "react";
import { Popover as AntPopover } from "antd";

interface PopoverProps {
  children: React.ReactNode;
  content: React.ReactNode;
  isOpen?: boolean;
}

const Popover: FunctionComponent<PopoverProps> = ({
  children,
  content,
  isOpen,
}) => {
  return (
    <AntPopover
      open={isOpen}
      content={content}
      styles={{
        body: {
          padding: 0,
        },
      }}
      arrow={false}>
      {children}
    </AntPopover>
  );
};

export { Popover };
